<template>
<div>
	<Card :title="title||'订单基本信息'">
        <Form :label-width="120" class="mt15">
			<Row>
                <Col span="12" v-if="type=='order'">
					<FormItem label="订单编号：">
						<span class="lineFeed">{{ info.orderNo }}</span>
					</FormItem>
				</Col>
				<Col span="12" v-if="type=='rider'">
					<FormItem label="批单凭证号：">
						<span class="lineFeed">{{ info.endorseNo }}</span>
					</FormItem>
				</Col>
				<Col span="12" v-if="type=='rider'">
					<FormItem label="批单编号：">
						<span class="lineFeed">{{ info.endorsePolicyNo }}</span>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="产品名称：">
						{{ info.productName }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="投保公司：">
						{{ info.applicantName }}
					</FormItem>
				</Col>
				<template v-if="type=='rider'">
					<Col span="12">
						<FormItem label="批单状态：">
							{{ info.endorseStatusDesc }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="批单创建时间：">
							{{ info.createTime }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="保单编号：">
							<a :href="'#/my/customizedCCIC/policyDetail/'+(info.cntrNo?info.cntrNo:info.guaranteeNo)" target="_blank" rel="opener" class="lineFeed">{{ info.cntrNo?info.cntrNo:info.guaranteeNo }}</a>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="订单编号：">
							<a :href="'#/my/customizedCCIC/orderDetail/'+info.orderNo" target="_blank" rel="opener" class="lineFeed">{{ info.orderNo }}</a>
						</FormItem>
					</Col>
					<Col span="12" v-if="info.endorseStatus=='FINISHED'">
						<FormItem label="批单确认时间：">
							{{ info.updateTime }}
						</FormItem>
					</Col>
					<Col span="24">
						<FormItem label="批改申请书：">
							<div v-for="(item,index) in imgList" :key="index" style="word-wrap:break-word; word-break:break-all;">
								{{ item }}
								<a :href="item" target="_blank" rel="opener" class="ml15">查看</a>
							</div>
						</FormItem>
						<FormItem label="批单附件：" v-if="info.electronicEndorseUrl">
							<a :href="info.electronicEndorseUrl" target="_blank" rel="opener" class="ml15">查看</a>
						</FormItem>
					</Col>
				</template>
				<template v-if="type=='order'">
					<Col span="12">
						<FormItem label="保险公司：">
							{{ info.companyName }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="订单状态：">
							{{ info.orderStatusDesc }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="支付方式：">
							{{ info.paymentSourceDesc || '无' }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="订单创建时间：">
							{{ info.createTime }}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="订单支付时间：">
							{{ info.paymentTime }}
						</FormItem>
					</Col>
					<Col span="12" v-if="!info.endorseNo">
						<FormItem label="投保单编号：">
							<a :href="'#/my/customizedCCIC/insuranceDetail/'+info.applicationNo" target="_blank" rel="opener" class="lineFeed">{{ info.applicationNo }}</a>
						</FormItem>
					</Col>
					<Col span="12" v-if="info.endorseNo">
						<FormItem label="批单凭证号：">
							<a :href="'#/my/customizedCCIC/riderDetail/'+info.endorseNo" target="_blank" rel="opener" class="lineFeed">{{ info.endorseNo }}</a>
						</FormItem>
					</Col>
					<Col span="12" v-if="info.extraInfo&&info.extraInfo.endorsePolicyNo">
						<FormItem label="批单编号：">
							<span class="lineFeed">{{ info.extraInfo.endorsePolicyNo }}</span>
						</FormItem>
					</Col>
					<Col span="12" v-if="info.paymentVoucherUrl">
						<FormItem label="支付凭证：">
							<a :href="info.paymentVoucherUrl" target="_blank" rel="opener" class="lineFeed">查看</a>
						</FormItem>
					</Col>
				</template>
				<Col span="12">
					<FormItem label="创建人账号：">
						{{ info.userPhone }}
					</FormItem>
				</Col>
				<Col span="12" v-if="type=='order'">
					<FormItem label="订单类型：">
						{{info.polarityDesc}}
					</FormItem>
				</Col>
				<Col span="24"  v-if="type=='rider'&&info.remark">
					<FormItem label="备注：">
						{{ info.remark }}
					</FormItem>
				</Col>
			</Row>
		</Form>
    </Card>
	
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		title:String,
		type:{
			type:String,
			default(){
				return 'order'
			}
		},
	},
	computed:{
		imgList(){
			return this.info.subjectMatterUrls?this.info.subjectMatterUrls.split(','):[]
		}
	},
	methods:{
		// renew () {
		// 	this.$router.push(`/installer/fillin-order/${this.$route.params.id}?hrCode=${this.info.hrCode}`)
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/orderBasicInfo.vue